import Login from "./pages/login/index.jsx";
import './style/global.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Principal from './pages/principal/index.jsx';
import CadEmpresa from "./pages/cadastro/empresa/index.jsx";
import CadUsuario from "./pages/cadastro/usuario/index.jsx";
import CadFuncionario from "./pages/cadastro/funcionario/index.jsx";
import CadFornecedor from "./pages/cadastro/fornecedor/index.jsx";
import CadCliente from "./pages/cadastro/cliente/index.jsx";
import CadCaixa from "./pages/cadastro/caixa/index.jsx";
import CadMoeda from "./pages/cadastro/moeda/index.jsx";
import CadCategoria from "./pages/cadastro/categoria/index.jsx";
import CadProduto from "./pages/cadastro/produto/index.jsx";
import OpePedido from "./pages/operacoes/pedido/index.jsx";
import OpeOrcamento from "./pages/operacoes/orcamento/index.jsx";
import OpeContasPagar from "./pages/operacoes/contaspagar/index.jsx";
import OpeContasReceber from "./pages/operacoes/contasreceber/index.jsx";
import OpeRelacaoNota from "./pages/operacoes/relacaonota/index.jsx";
import OpeEntradaMercadoria from "./pages/operacoes/entradamercadoria/index.jsx";
import RelEstoquePorEmpresa from "./pages/relatorio/estoqueporempresa/index.jsx";
import RelPedidos from "./pages/relatorio/relpedido/index.jsx";
import RelRecebimentoPorMoeda from "./pages/relatorio/relrecebimentopormoeda/index.jsx";
import { AppProvider } from './pages/context/AppContext.jsx';
import { Toaster } from 'react-hot-toast';
import PrivateRoute from "./componente/PrivateRoute.jsx"; // novo componente

function App() {
  return (
    <AppProvider>
      <Toaster position="top-right" reverseOrder={false} />
      <Router>
        <div>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/principal" element={<PrivateRoute><Principal /></PrivateRoute>} />
            <Route path="/cad/empresa" element={<PrivateRoute><CadEmpresa /></PrivateRoute>} />
            <Route path="/cad/usuario" element={<PrivateRoute><CadUsuario /></PrivateRoute>} />
            <Route path="/cad/funcionario" element={<PrivateRoute><CadFuncionario /></PrivateRoute>} />
            <Route path="/cad/fornecedor" element={<PrivateRoute><CadFornecedor /></PrivateRoute>} />
            <Route path="/cad/cliente" element={<PrivateRoute><CadCliente /></PrivateRoute>} />
            <Route path="/cad/caixa" element={<PrivateRoute><CadCaixa /></PrivateRoute>} />
            <Route path="/cad/moeda" element={<PrivateRoute><CadMoeda /></PrivateRoute>} />
            <Route path="/cad/categoria" element={<PrivateRoute><CadCategoria /></PrivateRoute>} />
            <Route path="/cad/produto" element={<PrivateRoute><CadProduto /></PrivateRoute>} />

            <Route path="/ope/pedido" element={<PrivateRoute><OpePedido /></PrivateRoute>} />
            <Route path="/ope/orcamento" element={<PrivateRoute><OpeOrcamento /></PrivateRoute>} />
            <Route path="/ope/contaspagar" element={<PrivateRoute><OpeContasPagar /></PrivateRoute>} />
            <Route path="/ope/contasreceber" element={<PrivateRoute><OpeContasReceber /></PrivateRoute>} />
            <Route path="/ope/relacaonota" element={<PrivateRoute><OpeRelacaoNota /></PrivateRoute>} />
            <Route path="/ope/entradaprodutos" element={<PrivateRoute><OpeEntradaMercadoria /></PrivateRoute>} />

            <Route path="/rel/estoqueporempresa" element={<PrivateRoute><RelEstoquePorEmpresa /></PrivateRoute>} />
            <Route path="/rel/relpedido" element={<PrivateRoute><RelPedidos /></PrivateRoute>} />
            <Route path="/rel/relrecebimentopormoeda" element={<PrivateRoute><RelRecebimentoPorMoeda /></PrivateRoute>} />
          </Routes>
        </div>
      </Router>
    </AppProvider>
  );
}

export default App;
